import { cloneDeep } from 'lodash'

export const appleMembershipEntity: AppleMembershipEntity = {
    accountId: 0,
    state: '',
    expirationDate: '',
}

export const brandSettingsEntity: BrandSettingsEntity = {
    id: 0,
    webviewVersion: true,
    webviewVersionAndroid: true,
    addressFirst: false,
    pushSendLimit: false,
}

export const brandEntity: BrandEntity = {
    id: 0,
    encodedName: '',
    name: '',
    logo: '',
    numberOfStores: 0,
    created: '',
    settings: brandSettingsEntity,
}

export const appAccountEntity: AppAccountEntity = {
    id: 0,
    teamName: '',
    apiKey: '',
    ddEmail: '',
    email: '',
    ddPassword: '',
    password: '',
    teamId: '',
    ddFastlanePassword: '',
    fastlanePassword: '',
    phoneNumber: '',
    lastModified: '',
    type: '',
    androidType: '',
    createdBy: '',
    createdAt: '',
    developerProgramRegisteredAt: '',
    corporateDocument: '',
    corporateName: '',
    duns: '',
    domain: '',
    securityQuestion1: '',
    securityQuestion2: '',
    securityQuestion3: '',
    securityAnswer1: '',
    securityAnswer2: '',
    securityAnswer3: '',
    hasDevPermissions: false,
    sessionMissingOrExpired: false,
}

export const appUpdate: AppUpdateEntity = {
    id: 0,
    status: 'REQUESTED',
    version: '',
    cxRequester: '',
    requireScreenshotsUpdate: false,
    priority: 0,
    lastModified: '',
}

export const appInfoEntity: AppInfoEntity = {
    url: '',
    version: '',
    updates: [],
    request: false,
    appleMembership: appleMembershipEntity,
}

export const appScreenshotEntity: AppScreenshotEntity = {
    id: 0,
    url: '',
    size: '',
}

export const appEntity: AppEntity = {
    id: 0,
    name: '',
    description: '',
    comment: '',
    warningLevel: 0,
    errorList: [],
    logo: '',
    banner: '',
    splashscreen: '',
    backgroundColor: '',
    color: '',
    idSuffix: '',
    bundleId: '',
    brand: cloneDeep(brandEntity),
    android: cloneDeep(appInfoEntity),
    iOS: cloneDeep(appInfoEntity),
    account: cloneDeep(appAccountEntity),
    errors: {},
    validateOnlyRequested: false,
}

export const modulecategoryEntity: ModulecategoryEntity = {
    id: 0,
    name: '',
}

export const modulepartnerEntity: ModulepartnerEntity = {
    id: 0,
    name: '',
    website: '',
    typeSupportContact: 'EMAIL',
    supportContact: '',
}

export const integrationModuleEntity: IntegrationModuleEntity = {
    id: 0,
    name: '',
    resume: '',
    description: '',
    logo: '',
    link: '',
    isSpotlight: false,
    viewOrder: 0,
    status: 'ACTIVE',
    isDiscount: false,
    fromPrice: '',
    price: '',
    priceType: 'FREE',
    category: cloneDeep(modulecategoryEntity),
    partner: cloneDeep(modulepartnerEntity),
}

export const partnerApikeyEntity: PartnerApikeyEntity = {
    clientId: '',
    clientSecret: '',
    status: 'ACTIVE',
}

export const partnerStoreEntity: PartnerStoreEntity = {
    id: 0,
    link: '',
    xDeliveryDiretoId: '',
    status: 'SANDBOX',
}

export const partnerCategoryEntity: PartnerCategoryEntity = {
    id: '',
    name: '',
}

export const partnerAddressEntity: PartnerAddressEntity = {
    id: 0,
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    zipcode: '',
}

export const partnerTecnicalContactEntity: PartnerContactEntity = {
    name: '',
    email: '',
    phone: '',
}

export const partnerSupportContactEntity: PartnerContactEntity = {
    name: '',
    typeContact: 'EMAIL',
    email: '',
    phone: '',
}

export const partnerComercialContactEntity: PartnerContactEntity = {
    name: '',
    typeContact: 'EMAIL',
    email: '',
    phone: '',
}

export const partnerContactsEntity: PartnerContactsEntity = {
    tecnical: cloneDeep(partnerTecnicalContactEntity),
    support: cloneDeep(partnerSupportContactEntity),
    comercial: cloneDeep(partnerComercialContactEntity),
}

export const partnerEntity: PartnerEntity = {
    id: 0,
    name: '',
    email: '',
    phone: '',
    website: '',
    company: '',
    cnpj: '',
    status: 'INITIATED',
    category: cloneDeep(partnerCategoryEntity),
    store: cloneDeep(partnerStoreEntity),
    address: cloneDeep(partnerAddressEntity),
    apikey: cloneDeep(partnerApikeyEntity),
    contacts: cloneDeep(partnerContactsEntity),
    notes: '',
    howManyClientsUsingPartner: '',
    howManyPartnerClientsUsingDD: '',
    howPartnerFindOutOurApi: '',
    whyPartnerWantsToIntegrate: '',
    errors: {},
}
